import ListeReleverComtabiliteTable from "../../../tables/comptabilite/ListeUsersComtabiliteTable/ListeReleverComtabiliteTable";
import "./ListeUsersComptabilite.css";

const ListeReleverComptabilite = () => {
  return (
    <div className="dashboard-admin-component">
      <div className="container-dashboard-page">
        <div className="admin-page-title-header-container flex-sb align-items-center">
          <div className="fast-facture-dash-locataire-requetes-header">
            <h4 className="fast-facture-dash-header-titre">
              Relevés bancaires
            </h4>
          </div>
        </div>
        <div className="col-left-dashboard col-left-dashboard-responsive mb-3">
          <div className="bg-white p-3">
            <ListeReleverComtabiliteTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListeReleverComptabilite;
